import React, {
  useState
}                                   from 'react';
import { historyPropType }          from '~/config/routerPropTypes';
import Request                      from '~/providers/Request';
import {
  showPerson,
  newPerson
}                                   from '~/config/routes';
import PersonRecord                 from '~/records/PersonRecord';
import Form                         from './Form';

function NewPerson({history}) {
  const [ record, setRecord] = useState(new PersonRecord());
  const [ loading, setLoading ] = useState(false);
  const [ dependentOwner, setDependentOwner ] = useState(null);

  async function onSubmit (saveAndContinue){
    const data = record.toParams({
      dependent_owner_id: dependentOwner ? dependentOwner.id : null
    });

    Request.post('/admin/users', data, {}, { controller: 'person' })
      .then(async (resp) => {
        const data = resp.data;
        const imageBase64 = record.get('image_base64');

        setLoading(true);

        if(imageBase64){
          try {
            const result = await Request.post('/upload_base64', { file: `data:image/jpg;base64,${imageBase64}`, user_id: data.id});
            console.log('upload Image', result);
          } catch(e) {console.log(e);}
        }

        setLoading(false);
        if(saveAndContinue){
          history.push(newPerson.spec);
        } else{
          history.push(showPerson.reverse(resp.data));
        }
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    if( attrs.hasOwnProperty('dependentOwner') ){
      return setDependentOwner( attrs.dependentOwner );
    }
    setRecord( record.updateAttributes(attrs) );
  };

  return (
    <Form
      loading={loading}
      record={record}
      handleChange={handleChange}
      setRecord={setRecord}
      onSubmit={onSubmit}
      title='newPerson'
      dependentOwner={dependentOwner}
    />
  );
}

  NewPerson.propTypes={
    history: historyPropType,
  };

export default (NewPerson);
